import { createSlice } from '@reduxjs/toolkit';

import { RESCHEDULE_CLASSES_FILTERS } from '@classCreation/data/rescheduleClassesFilters';

const initialState = {
  isModalOpen: false,
  primaryInstructors: { applied: '', current: '' },
  secondaryInstructors: { applied: '', current: '' },
  academyModules: { applied: null, current: null },
  classType: { applied: null, current: null },
  lectureType: { applied: null, current: null },
  fromDate: { applied: null, current: null },
  toDate: { applied: null, current: null },
};

export const rescheduleClassesFilter = createSlice({
  name: 'rescheduleClassesFilter',
  initialState,
  reducers: {
    setRescheduleClassesFilterModalState: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setRescheduleFilterValue: (state, action) => {
      const { type, key, value } = action.payload;
      state[key][type] = value;
    },
    applyCurrentRescheduleFilter: (state, action) => {
      for (const key in RESCHEDULE_CLASSES_FILTERS) {
        state[key].applied = state[key].current;
      }
      state.isModalOpen = false;
    },
    removeRescheduleFilter: (state, action) => {
      state[action.payload] = initialState[action.payload];
    },
    resetRescheduleFilters: (state) => {
      for (const key in RESCHEDULE_CLASSES_FILTERS) {
        state[key] = initialState[key];
      }
    },
  },
});

export const {
  setRescheduleClassesFilterModalState,
  applyCurrentRescheduleFilter,
  removeRescheduleFilter,
  resetRescheduleFilters,
  setRescheduleFilterValue,
} = rescheduleClassesFilter.actions;

export default rescheduleClassesFilter.reducer;
